export const getSsoLoginUrl = (config) => {
  const configuredUrl =
    config?.SSO_LOGIN_URL ||
    config?.ssoLoginUrl ||
    config?.Saml2?.LoginUrl ||
    config?.saml2?.loginUrl;

  if (configuredUrl) {
    return configuredUrl;
  }

  const apiUrl = config?.API_URL;
  if (!apiUrl) {
    throw new Error("Unable to resolve SSO login URL because API_URL is missing.");
  }

  const parsedApiUrl = new URL(apiUrl, window.location.origin);
  return new URL('/Saml2/Login', parsedApiUrl.origin).toString();
};
